import { __assign, __extends, __spreadArrays } from "tslib";
var DS_SERVER_BASE = 'https://apps.wix.com';
var dsServerUrl = function (siteHeaderUrl, useAbsolutePath) {
    if (useAbsolutePath === void 0) { useAbsolutePath = false; }
    return (useAbsolutePath ? DS_SERVER_BASE : '') + "/document-services-server/v2/query/apps/" + siteHeaderUrl;
};
var RemoteStructureFetcherError = /** @class */ (function (_super) {
    __extends(RemoteStructureFetcherError, _super);
    function RemoteStructureFetcherError(message, body) {
        var _this = _super.call(this, message) || this;
        _this.name = 'RemoteStructureFetcherError';
        /* istanbul ignore next */
        _this.body = typeof body === 'string' ? body.slice(0, 10240) : body;
        return _this;
    }
    return RemoteStructureFetcherError;
}(Error));
var fetchDS = function (siteHeaderUrl, resource, options) {
    return fetch("" + dsServerUrl(siteHeaderUrl, options.useAbsolutePath) + resource, {
        credentials: 'include',
    }).then(function (res) {
        if (res.ok) {
            return res.json();
        }
        return res
            .text()
            .catch(function () {
            throw new Error("Remote structure fetcher has failed with status " + res.status);
        })
            .then(function (body) {
            throw new RemoteStructureFetcherError("Remote structure fetcher has failed with status " + res.status, body);
        });
    });
};
var getWidgetId = function (_a) {
    var rootCompId = _a.rootCompId;
    return rootCompId[0] === '#' ? rootCompId.substr(1) : rootCompId;
};
export var getWidgetStructure = function (siteHeaderUrl, widgetId, options) {
    if (options === void 0) { options = {}; }
    return fetchDS(siteHeaderUrl, "/widget/" + widgetId, options);
};
export var getWidgetStructureByAppData = function (appData, widgetPageId, variationId, options) {
    if (options === void 0) { options = {}; }
    var appDefinitionId = appData.appDefinitionId, widgets = appData.widgets;
    var siteHeaderUrl = getSiteHeaderUrl(appData);
    if (!siteHeaderUrl) {
        throw new Error('siteHeaderUrl was not found');
    }
    var devCenterWidgetId = Object.keys(widgets).find(function (key) { var _a, _b; return ((_b = (_a = widgets[key].componentFields) === null || _a === void 0 ? void 0 : _a.appStudioFields) === null || _b === void 0 ? void 0 : _b.id) === widgetPageId; });
    var createVariationIdParam = function () { return "&variationId=" + variationId; };
    var url = "/app_widget/" + widgetPageId + "?appDefinitionId=" + appDefinitionId + "&devCenterWidgetId=" + devCenterWidgetId + (variationId ? createVariationIdParam() : '');
    return fetchDS(siteHeaderUrl, url, options).then(function (_a) {
        var APP_WIDGET = _a.APP_WIDGET;
        return APP_WIDGET;
    });
};
/**
 * @description Fetches the appDescriptor from DS Server
 * @returns An object with widgets property, keys are widgetId, value is widget descriptor
 */
export var getAppDescriptor = function (siteHeaderUrl, options) {
    if (options === void 0) { options = {}; }
    return fetchDS(siteHeaderUrl, '/app', options).then(function (app) {
        var APP_DESCRIPTOR = app.APP_DESCRIPTOR;
        var appDescriptor = Array.isArray(APP_DESCRIPTOR)
            ? { widgets: APP_DESCRIPTOR }
            : APP_DESCRIPTOR;
        var widgets = appDescriptor.widgets
            ? appDescriptor.widgets.reduce(function (acc, value) {
                acc[getWidgetId(value)] = value;
                return acc;
            }, {})
            : {};
        return __assign(__assign({}, appDescriptor), { widgets: widgets, customDefinitions: Object.assign.apply(Object, __spreadArrays([{}], (appDescriptor.customDefinitions || []))) });
    });
};
export var getSiteHeaderUrl = function (appData) {
    var _a, _b, _c, _d;
    var result = ((_b = (_a = appData.appFields.platform) === null || _a === void 0 ? void 0 : _a.baseUrls) === null || _b === void 0 ? void 0 : _b.siteHeaderUrl) || ((_d = (_c = appData.appFields.platform) === null || _c === void 0 ? void 0 : _c.studio) === null || _d === void 0 ? void 0 : _d.siteHeaderUrl);
    if (!result) {
        throw new Error('siteHeaderUrl was not found');
    }
    return result;
};
//# sourceMappingURL=remoteStructureFetcher.js.map